<template>
  <label :class="wrapperClasses" :disabled="disabled" :checked="currentChecked">
    <input
      ref="input"
      type="radio"
      :class="inputClasses"
      :disabled="disabled"
      :checked="currentChecked"
      @change="$_onChange"
    >
    <span :class="innerClasses">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
import { PREFIX_CLASS } from '../../utils/constants'
import Emitter from '../../mixins/emitter'
const PREFIX_CLS = `${PREFIX_CLASS}form-radio`

export default {
  name: 'TRadio',
  mixins: [Emitter],
  props: {
    value: {
      type: [Boolean, String, Number, Array, Object, Function, Symbol, Date],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '',
      validator(val) {
        /* istanbul ignore next */
        return ['lg', 'sm', ''].includes(val)
      }
    }
  },
  inject: {
    groupVM: { default: null }
  },
  data() {
    return {
      currentChecked: false
    }
  },
  computed: {
    wrapperClasses() {
      return [
        PREFIX_CLS,
        {
          [`${PREFIX_CLS}-group-item`]: this.group,
          [`${PREFIX_CLS}--${this.size}`]: !!this.size
        }
      ]
    },
    innerClasses() {
      return `${PREFIX_CLS}__inner`
    },
    inputClasses() {
      return `${PREFIX_CLS}__input`
    },
    prop () {
      let parent = this.$parent
      while (parent && parent.$options && parent.$options.name !== 'TFormItem') {
        parent = parent.$parent
      }
      return (parent && parent.prop) || ''
    },
    finalValue () {
      if (this.value !== null) {
        return this.value
      } else {
        return this.label
      }
    }
  },
  watch: {
    checked(val) {
      this.currentChecked = val
    }
  },
  mounted() {
    if (this.groupVM) {
      this.unwatch = this.$watch('groupVM.value', (newVal) => {
        this.currentChecked = newVal === this.finalValue
      })
      this.currentChecked = this.groupVM.value === this.finalValue
    } else {
      this.currentChecked = this.checked
    }
  },
  destroyed() {
    this.unwatch && this.unwatch()
  },
  methods: {
    focus() {
      this.$refs.input.$el.focus()
    },
    $_onChange(evt) {
      if (this.disabled) {
        return false
      }
      if (!evt.target) {
        return false
      }
      const checked = evt.target.checked
      this.currentChecked = checked
      this.$_emitEvents(checked)
    },
    $_emitEvents(checked) {
      if (this.groupVM) {
        this.groupVM.$_onChange(this.finalValue)
      } else {
        this.$emit('update:checked', checked)
        this.$emit('change', checked)
        // NOTE: 用于form验证
        this.dispatch('TFormItem', 'g-on-form-change', checked)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/radio/radio.vue